import { getVehicleList, addVehicle, delVehicle, membervehicleEdit } from "@/api/comCart";

export default {
  namespaced: true,
  actions: {
    async getVehicleList(context, params) {
      const res = await getVehicleList(params);
      return res;
    },
    async membervehicleEdit(context, params) {
      const res = await membervehicleEdit(params);
      return res;
    },
    async addVehicle(context, params) {
      const res = await addVehicle(params);
      return res;
    },

    async delVehicle(context, params) {
      const res = await delVehicle(params);
      return res;
    }
  }
};
